import { createAction, props } from '@ngrx/store';

import type { SolarPanelsWizardFormValues } from './form-ids';

const PREFIX = '[Solar Panels Wizard]';

export const solarPanelsWizardFormSubmitAction = createAction(
  `${PREFIX} Submit form`,
  props<{
    formValues: SolarPanelsWizardFormValues;
  }>()
);
